import { VoiceRecorder } from "./VoiceRecorder";
import { useSelector } from "react-redux";
import { closeAddCard, refreshCards } from "../store/cards.dispatch";
import UploadImage from "./UploadImage";
import { FaCheck } from "react-icons/fa";
import { useEffect, useState } from "react";

export const CreateCard = () => {
  const cardId = useSelector(state => state.cards.editCardId);
  const [hasVoice, setHasVoice] = useState(false);
  const [hasImage, setHasImage] = useState(false);
  const isVisible = cardId !== null;

  const onVoiceUpdate = val => setHasVoice(val);
  const onImageUpdate = val => setHasImage(val);

  useEffect(() => {
    console.log('hasVoice', hasVoice);
    console.log('hasImage', hasImage);
  },[hasImage,hasVoice])

  return isVisible ? (
    <div
      className="
        fixed
        z-10
        top-0
        left-0
        w-full
        h-screen
        flex
        flex-col
        justify-center
        items-center
        bg-slate-400"
    >
      <div
        className="
          w-11/12
          md:w-6/12
          lg:w-6/12
          xl:w-4/12
          w-
          m-2
          p-8
          bg-c5
          rounded-md
        "
      >
        <h3>🖐️ Create a new card</h3>
        <div className="flex c1 flex-row space-x-2 items-center mt-3">
          <div className="relative">
            <span className="rounded-full border-c1 p-2 text-xs">01</span>
            {hasImage && <FaCheck className="faCheck absolute ml-4 -mt-2" />}
          </div>
          <span>Lets take a picture</span>
        </div>

        <span className="mt-3">
          <UploadImage
            cardId={cardId}
            onImageUpdate={onImageUpdate}
          />
        </span>

        <div className="flex c1 flex-row mt-2 space-x-2 items-center">
          <div className="relative">
            <span className="rounded-full border-c1 p-2 text-xs">02</span>
            {hasVoice && <FaCheck className="faCheck absolute ml-4 -mt-2" />}
          </div>
          <span>Record your voice</span>
        </div>
        <VoiceRecorder
          cardId={cardId}
          isVisible={true}
          onVoiceUpdate={onVoiceUpdate}
        />
        <div className="flex space-x-2 mt-4">
          <button className="py-3 px-4 bg-c1 c5 rounded-md" onClick={() => {
            closeAddCard();
            refreshCards();
          }}>
            {hasImage && hasVoice ? 'Save' : 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  ) : null;
};
